// Ce fichier est généré automatiquement par utils/spritesheet-config-generator
// Ne pas modifier manuellement
// Dossier: spider | Taille: 256x256px

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const SpiderSpritesheetConfig: ISpritesheetMetadata[] = [
  {
    name: 'spider-attack',
    metadata: {
      frames: {
        'spider-attack-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-attack-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/spider/attack.png',
        size: {
          w: 5120,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'spider-attack-bottom': [
          'spider-attack-bottom-0',
          'spider-attack-bottom-1',
          'spider-attack-bottom-2',
          'spider-attack-bottom-3',
          'spider-attack-bottom-4',
          'spider-attack-bottom-5',
          'spider-attack-bottom-6',
          'spider-attack-bottom-7',
          'spider-attack-bottom-8',
          'spider-attack-bottom-9',
          'spider-attack-bottom-10',
          'spider-attack-bottom-11',
          'spider-attack-bottom-12',
          'spider-attack-bottom-13',
          'spider-attack-bottom-14',
          'spider-attack-bottom-15',
          'spider-attack-bottom-16',
          'spider-attack-bottom-17',
          'spider-attack-bottom-18',
          'spider-attack-bottom-19',
        ],
        'spider-attack-bottom-left': [
          'spider-attack-bottom-left-0',
          'spider-attack-bottom-left-1',
          'spider-attack-bottom-left-2',
          'spider-attack-bottom-left-3',
          'spider-attack-bottom-left-4',
          'spider-attack-bottom-left-5',
          'spider-attack-bottom-left-6',
          'spider-attack-bottom-left-7',
          'spider-attack-bottom-left-8',
          'spider-attack-bottom-left-9',
          'spider-attack-bottom-left-10',
          'spider-attack-bottom-left-11',
          'spider-attack-bottom-left-12',
          'spider-attack-bottom-left-13',
          'spider-attack-bottom-left-14',
          'spider-attack-bottom-left-15',
          'spider-attack-bottom-left-16',
          'spider-attack-bottom-left-17',
          'spider-attack-bottom-left-18',
          'spider-attack-bottom-left-19',
        ],
        'spider-attack-left': [
          'spider-attack-left-0',
          'spider-attack-left-1',
          'spider-attack-left-2',
          'spider-attack-left-3',
          'spider-attack-left-4',
          'spider-attack-left-5',
          'spider-attack-left-6',
          'spider-attack-left-7',
          'spider-attack-left-8',
          'spider-attack-left-9',
          'spider-attack-left-10',
          'spider-attack-left-11',
          'spider-attack-left-12',
          'spider-attack-left-13',
          'spider-attack-left-14',
          'spider-attack-left-15',
          'spider-attack-left-16',
          'spider-attack-left-17',
          'spider-attack-left-18',
          'spider-attack-left-19',
        ],
        'spider-attack-top-left': [
          'spider-attack-top-left-0',
          'spider-attack-top-left-1',
          'spider-attack-top-left-2',
          'spider-attack-top-left-3',
          'spider-attack-top-left-4',
          'spider-attack-top-left-5',
          'spider-attack-top-left-6',
          'spider-attack-top-left-7',
          'spider-attack-top-left-8',
          'spider-attack-top-left-9',
          'spider-attack-top-left-10',
          'spider-attack-top-left-11',
          'spider-attack-top-left-12',
          'spider-attack-top-left-13',
          'spider-attack-top-left-14',
          'spider-attack-top-left-15',
          'spider-attack-top-left-16',
          'spider-attack-top-left-17',
          'spider-attack-top-left-18',
          'spider-attack-top-left-19',
        ],
        'spider-attack-top': [
          'spider-attack-top-0',
          'spider-attack-top-1',
          'spider-attack-top-2',
          'spider-attack-top-3',
          'spider-attack-top-4',
          'spider-attack-top-5',
          'spider-attack-top-6',
          'spider-attack-top-7',
          'spider-attack-top-8',
          'spider-attack-top-9',
          'spider-attack-top-10',
          'spider-attack-top-11',
          'spider-attack-top-12',
          'spider-attack-top-13',
          'spider-attack-top-14',
          'spider-attack-top-15',
          'spider-attack-top-16',
          'spider-attack-top-17',
          'spider-attack-top-18',
          'spider-attack-top-19',
        ],
      },
    },
  },
  {
    name: 'spider-die',
    metadata: {
      frames: {
        'spider-die-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-20': {
          frame: {
            x: 5120,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-21': {
          frame: {
            x: 5376,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-22': {
          frame: {
            x: 5632,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-23': {
          frame: {
            x: 5888,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-20': {
          frame: {
            x: 5120,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-21': {
          frame: {
            x: 5376,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-22': {
          frame: {
            x: 5632,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-bottom-left-23': {
          frame: {
            x: 5888,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-20': {
          frame: {
            x: 5120,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-21': {
          frame: {
            x: 5376,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-22': {
          frame: {
            x: 5632,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-left-23': {
          frame: {
            x: 5888,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-20': {
          frame: {
            x: 5120,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-21': {
          frame: {
            x: 5376,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-22': {
          frame: {
            x: 5632,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-left-23': {
          frame: {
            x: 5888,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-20': {
          frame: {
            x: 5120,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-21': {
          frame: {
            x: 5376,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-22': {
          frame: {
            x: 5632,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-die-top-23': {
          frame: {
            x: 5888,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/spider/die.png',
        size: {
          w: 6144,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'spider-die-bottom': [
          'spider-die-bottom-0',
          'spider-die-bottom-1',
          'spider-die-bottom-2',
          'spider-die-bottom-3',
          'spider-die-bottom-4',
          'spider-die-bottom-5',
          'spider-die-bottom-6',
          'spider-die-bottom-7',
          'spider-die-bottom-8',
          'spider-die-bottom-9',
          'spider-die-bottom-10',
          'spider-die-bottom-11',
          'spider-die-bottom-12',
          'spider-die-bottom-13',
          'spider-die-bottom-14',
          'spider-die-bottom-15',
          'spider-die-bottom-16',
          'spider-die-bottom-17',
          'spider-die-bottom-18',
          'spider-die-bottom-19',
          'spider-die-bottom-20',
          'spider-die-bottom-21',
          'spider-die-bottom-22',
          'spider-die-bottom-23',
        ],
        'spider-die-bottom-left': [
          'spider-die-bottom-left-0',
          'spider-die-bottom-left-1',
          'spider-die-bottom-left-2',
          'spider-die-bottom-left-3',
          'spider-die-bottom-left-4',
          'spider-die-bottom-left-5',
          'spider-die-bottom-left-6',
          'spider-die-bottom-left-7',
          'spider-die-bottom-left-8',
          'spider-die-bottom-left-9',
          'spider-die-bottom-left-10',
          'spider-die-bottom-left-11',
          'spider-die-bottom-left-12',
          'spider-die-bottom-left-13',
          'spider-die-bottom-left-14',
          'spider-die-bottom-left-15',
          'spider-die-bottom-left-16',
          'spider-die-bottom-left-17',
          'spider-die-bottom-left-18',
          'spider-die-bottom-left-19',
          'spider-die-bottom-left-20',
          'spider-die-bottom-left-21',
          'spider-die-bottom-left-22',
          'spider-die-bottom-left-23',
        ],
        'spider-die-left': [
          'spider-die-left-0',
          'spider-die-left-1',
          'spider-die-left-2',
          'spider-die-left-3',
          'spider-die-left-4',
          'spider-die-left-5',
          'spider-die-left-6',
          'spider-die-left-7',
          'spider-die-left-8',
          'spider-die-left-9',
          'spider-die-left-10',
          'spider-die-left-11',
          'spider-die-left-12',
          'spider-die-left-13',
          'spider-die-left-14',
          'spider-die-left-15',
          'spider-die-left-16',
          'spider-die-left-17',
          'spider-die-left-18',
          'spider-die-left-19',
          'spider-die-left-20',
          'spider-die-left-21',
          'spider-die-left-22',
          'spider-die-left-23',
        ],
        'spider-die-top-left': [
          'spider-die-top-left-0',
          'spider-die-top-left-1',
          'spider-die-top-left-2',
          'spider-die-top-left-3',
          'spider-die-top-left-4',
          'spider-die-top-left-5',
          'spider-die-top-left-6',
          'spider-die-top-left-7',
          'spider-die-top-left-8',
          'spider-die-top-left-9',
          'spider-die-top-left-10',
          'spider-die-top-left-11',
          'spider-die-top-left-12',
          'spider-die-top-left-13',
          'spider-die-top-left-14',
          'spider-die-top-left-15',
          'spider-die-top-left-16',
          'spider-die-top-left-17',
          'spider-die-top-left-18',
          'spider-die-top-left-19',
          'spider-die-top-left-20',
          'spider-die-top-left-21',
          'spider-die-top-left-22',
          'spider-die-top-left-23',
        ],
        'spider-die-top': [
          'spider-die-top-0',
          'spider-die-top-1',
          'spider-die-top-2',
          'spider-die-top-3',
          'spider-die-top-4',
          'spider-die-top-5',
          'spider-die-top-6',
          'spider-die-top-7',
          'spider-die-top-8',
          'spider-die-top-9',
          'spider-die-top-10',
          'spider-die-top-11',
          'spider-die-top-12',
          'spider-die-top-13',
          'spider-die-top-14',
          'spider-die-top-15',
          'spider-die-top-16',
          'spider-die-top-17',
          'spider-die-top-18',
          'spider-die-top-19',
          'spider-die-top-20',
          'spider-die-top-21',
          'spider-die-top-22',
          'spider-die-top-23',
        ],
      },
    },
  },
  {
    name: 'spider-dizzy',
    metadata: {
      frames: {
        'spider-dizzy-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-dizzy-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/spider/dizzy.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'spider-dizzy-bottom': [
          'spider-dizzy-bottom-0',
          'spider-dizzy-bottom-1',
          'spider-dizzy-bottom-2',
          'spider-dizzy-bottom-3',
          'spider-dizzy-bottom-4',
          'spider-dizzy-bottom-5',
          'spider-dizzy-bottom-6',
          'spider-dizzy-bottom-7',
          'spider-dizzy-bottom-8',
          'spider-dizzy-bottom-9',
          'spider-dizzy-bottom-10',
          'spider-dizzy-bottom-11',
          'spider-dizzy-bottom-12',
          'spider-dizzy-bottom-13',
          'spider-dizzy-bottom-14',
          'spider-dizzy-bottom-15',
        ],
        'spider-dizzy-bottom-left': [
          'spider-dizzy-bottom-left-0',
          'spider-dizzy-bottom-left-1',
          'spider-dizzy-bottom-left-2',
          'spider-dizzy-bottom-left-3',
          'spider-dizzy-bottom-left-4',
          'spider-dizzy-bottom-left-5',
          'spider-dizzy-bottom-left-6',
          'spider-dizzy-bottom-left-7',
          'spider-dizzy-bottom-left-8',
          'spider-dizzy-bottom-left-9',
          'spider-dizzy-bottom-left-10',
          'spider-dizzy-bottom-left-11',
          'spider-dizzy-bottom-left-12',
          'spider-dizzy-bottom-left-13',
          'spider-dizzy-bottom-left-14',
          'spider-dizzy-bottom-left-15',
        ],
        'spider-dizzy-left': [
          'spider-dizzy-left-0',
          'spider-dizzy-left-1',
          'spider-dizzy-left-2',
          'spider-dizzy-left-3',
          'spider-dizzy-left-4',
          'spider-dizzy-left-5',
          'spider-dizzy-left-6',
          'spider-dizzy-left-7',
          'spider-dizzy-left-8',
          'spider-dizzy-left-9',
          'spider-dizzy-left-10',
          'spider-dizzy-left-11',
          'spider-dizzy-left-12',
          'spider-dizzy-left-13',
          'spider-dizzy-left-14',
          'spider-dizzy-left-15',
        ],
        'spider-dizzy-top-left': [
          'spider-dizzy-top-left-0',
          'spider-dizzy-top-left-1',
          'spider-dizzy-top-left-2',
          'spider-dizzy-top-left-3',
          'spider-dizzy-top-left-4',
          'spider-dizzy-top-left-5',
          'spider-dizzy-top-left-6',
          'spider-dizzy-top-left-7',
          'spider-dizzy-top-left-8',
          'spider-dizzy-top-left-9',
          'spider-dizzy-top-left-10',
          'spider-dizzy-top-left-11',
          'spider-dizzy-top-left-12',
          'spider-dizzy-top-left-13',
          'spider-dizzy-top-left-14',
          'spider-dizzy-top-left-15',
        ],
        'spider-dizzy-top': [
          'spider-dizzy-top-0',
          'spider-dizzy-top-1',
          'spider-dizzy-top-2',
          'spider-dizzy-top-3',
          'spider-dizzy-top-4',
          'spider-dizzy-top-5',
          'spider-dizzy-top-6',
          'spider-dizzy-top-7',
          'spider-dizzy-top-8',
          'spider-dizzy-top-9',
          'spider-dizzy-top-10',
          'spider-dizzy-top-11',
          'spider-dizzy-top-12',
          'spider-dizzy-top-13',
          'spider-dizzy-top-14',
          'spider-dizzy-top-15',
        ],
      },
    },
  },
  {
    name: 'spider-hit',
    metadata: {
      frames: {
        'spider-hit-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-hit-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/spider/hit.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'spider-hit-bottom': [
          'spider-hit-bottom-0',
          'spider-hit-bottom-1',
          'spider-hit-bottom-2',
          'spider-hit-bottom-3',
          'spider-hit-bottom-4',
          'spider-hit-bottom-5',
          'spider-hit-bottom-6',
          'spider-hit-bottom-7',
          'spider-hit-bottom-8',
          'spider-hit-bottom-9',
          'spider-hit-bottom-10',
          'spider-hit-bottom-11',
          'spider-hit-bottom-12',
          'spider-hit-bottom-13',
          'spider-hit-bottom-14',
          'spider-hit-bottom-15',
        ],
        'spider-hit-bottom-left': [
          'spider-hit-bottom-left-0',
          'spider-hit-bottom-left-1',
          'spider-hit-bottom-left-2',
          'spider-hit-bottom-left-3',
          'spider-hit-bottom-left-4',
          'spider-hit-bottom-left-5',
          'spider-hit-bottom-left-6',
          'spider-hit-bottom-left-7',
          'spider-hit-bottom-left-8',
          'spider-hit-bottom-left-9',
          'spider-hit-bottom-left-10',
          'spider-hit-bottom-left-11',
          'spider-hit-bottom-left-12',
          'spider-hit-bottom-left-13',
          'spider-hit-bottom-left-14',
          'spider-hit-bottom-left-15',
        ],
        'spider-hit-left': [
          'spider-hit-left-0',
          'spider-hit-left-1',
          'spider-hit-left-2',
          'spider-hit-left-3',
          'spider-hit-left-4',
          'spider-hit-left-5',
          'spider-hit-left-6',
          'spider-hit-left-7',
          'spider-hit-left-8',
          'spider-hit-left-9',
          'spider-hit-left-10',
          'spider-hit-left-11',
          'spider-hit-left-12',
          'spider-hit-left-13',
          'spider-hit-left-14',
          'spider-hit-left-15',
        ],
        'spider-hit-top-left': [
          'spider-hit-top-left-0',
          'spider-hit-top-left-1',
          'spider-hit-top-left-2',
          'spider-hit-top-left-3',
          'spider-hit-top-left-4',
          'spider-hit-top-left-5',
          'spider-hit-top-left-6',
          'spider-hit-top-left-7',
          'spider-hit-top-left-8',
          'spider-hit-top-left-9',
          'spider-hit-top-left-10',
          'spider-hit-top-left-11',
          'spider-hit-top-left-12',
          'spider-hit-top-left-13',
          'spider-hit-top-left-14',
          'spider-hit-top-left-15',
        ],
        'spider-hit-top': [
          'spider-hit-top-0',
          'spider-hit-top-1',
          'spider-hit-top-2',
          'spider-hit-top-3',
          'spider-hit-top-4',
          'spider-hit-top-5',
          'spider-hit-top-6',
          'spider-hit-top-7',
          'spider-hit-top-8',
          'spider-hit-top-9',
          'spider-hit-top-10',
          'spider-hit-top-11',
          'spider-hit-top-12',
          'spider-hit-top-13',
          'spider-hit-top-14',
          'spider-hit-top-15',
        ],
      },
    },
  },
  {
    name: 'spider-idle',
    metadata: {
      frames: {
        'spider-idle-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-20': {
          frame: {
            x: 5120,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-21': {
          frame: {
            x: 5376,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-22': {
          frame: {
            x: 5632,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-23': {
          frame: {
            x: 5888,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-20': {
          frame: {
            x: 5120,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-21': {
          frame: {
            x: 5376,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-22': {
          frame: {
            x: 5632,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-bottom-left-23': {
          frame: {
            x: 5888,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-20': {
          frame: {
            x: 5120,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-21': {
          frame: {
            x: 5376,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-22': {
          frame: {
            x: 5632,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-left-23': {
          frame: {
            x: 5888,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-20': {
          frame: {
            x: 5120,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-21': {
          frame: {
            x: 5376,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-22': {
          frame: {
            x: 5632,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-left-23': {
          frame: {
            x: 5888,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-20': {
          frame: {
            x: 5120,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-21': {
          frame: {
            x: 5376,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-22': {
          frame: {
            x: 5632,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-idle-top-23': {
          frame: {
            x: 5888,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/spider/idle.png',
        size: {
          w: 6144,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'spider-idle-bottom': [
          'spider-idle-bottom-0',
          'spider-idle-bottom-1',
          'spider-idle-bottom-2',
          'spider-idle-bottom-3',
          'spider-idle-bottom-4',
          'spider-idle-bottom-5',
          'spider-idle-bottom-6',
          'spider-idle-bottom-7',
          'spider-idle-bottom-8',
          'spider-idle-bottom-9',
          'spider-idle-bottom-10',
          'spider-idle-bottom-11',
          'spider-idle-bottom-12',
          'spider-idle-bottom-13',
          'spider-idle-bottom-14',
          'spider-idle-bottom-15',
          'spider-idle-bottom-16',
          'spider-idle-bottom-17',
          'spider-idle-bottom-18',
          'spider-idle-bottom-19',
          'spider-idle-bottom-20',
          'spider-idle-bottom-21',
          'spider-idle-bottom-22',
          'spider-idle-bottom-23',
        ],
        'spider-idle-bottom-left': [
          'spider-idle-bottom-left-0',
          'spider-idle-bottom-left-1',
          'spider-idle-bottom-left-2',
          'spider-idle-bottom-left-3',
          'spider-idle-bottom-left-4',
          'spider-idle-bottom-left-5',
          'spider-idle-bottom-left-6',
          'spider-idle-bottom-left-7',
          'spider-idle-bottom-left-8',
          'spider-idle-bottom-left-9',
          'spider-idle-bottom-left-10',
          'spider-idle-bottom-left-11',
          'spider-idle-bottom-left-12',
          'spider-idle-bottom-left-13',
          'spider-idle-bottom-left-14',
          'spider-idle-bottom-left-15',
          'spider-idle-bottom-left-16',
          'spider-idle-bottom-left-17',
          'spider-idle-bottom-left-18',
          'spider-idle-bottom-left-19',
          'spider-idle-bottom-left-20',
          'spider-idle-bottom-left-21',
          'spider-idle-bottom-left-22',
          'spider-idle-bottom-left-23',
        ],
        'spider-idle-left': [
          'spider-idle-left-0',
          'spider-idle-left-1',
          'spider-idle-left-2',
          'spider-idle-left-3',
          'spider-idle-left-4',
          'spider-idle-left-5',
          'spider-idle-left-6',
          'spider-idle-left-7',
          'spider-idle-left-8',
          'spider-idle-left-9',
          'spider-idle-left-10',
          'spider-idle-left-11',
          'spider-idle-left-12',
          'spider-idle-left-13',
          'spider-idle-left-14',
          'spider-idle-left-15',
          'spider-idle-left-16',
          'spider-idle-left-17',
          'spider-idle-left-18',
          'spider-idle-left-19',
          'spider-idle-left-20',
          'spider-idle-left-21',
          'spider-idle-left-22',
          'spider-idle-left-23',
        ],
        'spider-idle-top-left': [
          'spider-idle-top-left-0',
          'spider-idle-top-left-1',
          'spider-idle-top-left-2',
          'spider-idle-top-left-3',
          'spider-idle-top-left-4',
          'spider-idle-top-left-5',
          'spider-idle-top-left-6',
          'spider-idle-top-left-7',
          'spider-idle-top-left-8',
          'spider-idle-top-left-9',
          'spider-idle-top-left-10',
          'spider-idle-top-left-11',
          'spider-idle-top-left-12',
          'spider-idle-top-left-13',
          'spider-idle-top-left-14',
          'spider-idle-top-left-15',
          'spider-idle-top-left-16',
          'spider-idle-top-left-17',
          'spider-idle-top-left-18',
          'spider-idle-top-left-19',
          'spider-idle-top-left-20',
          'spider-idle-top-left-21',
          'spider-idle-top-left-22',
          'spider-idle-top-left-23',
        ],
        'spider-idle-top': [
          'spider-idle-top-0',
          'spider-idle-top-1',
          'spider-idle-top-2',
          'spider-idle-top-3',
          'spider-idle-top-4',
          'spider-idle-top-5',
          'spider-idle-top-6',
          'spider-idle-top-7',
          'spider-idle-top-8',
          'spider-idle-top-9',
          'spider-idle-top-10',
          'spider-idle-top-11',
          'spider-idle-top-12',
          'spider-idle-top-13',
          'spider-idle-top-14',
          'spider-idle-top-15',
          'spider-idle-top-16',
          'spider-idle-top-17',
          'spider-idle-top-18',
          'spider-idle-top-19',
          'spider-idle-top-20',
          'spider-idle-top-21',
          'spider-idle-top-22',
          'spider-idle-top-23',
        ],
      },
    },
  },
  {
    name: 'spider-run',
    metadata: {
      frames: {
        'spider-run-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-run-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/spider/run.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'spider-run-bottom': [
          'spider-run-bottom-0',
          'spider-run-bottom-1',
          'spider-run-bottom-2',
          'spider-run-bottom-3',
          'spider-run-bottom-4',
          'spider-run-bottom-5',
          'spider-run-bottom-6',
          'spider-run-bottom-7',
          'spider-run-bottom-8',
          'spider-run-bottom-9',
          'spider-run-bottom-10',
          'spider-run-bottom-11',
          'spider-run-bottom-12',
          'spider-run-bottom-13',
          'spider-run-bottom-14',
          'spider-run-bottom-15',
        ],
        'spider-run-bottom-left': [
          'spider-run-bottom-left-0',
          'spider-run-bottom-left-1',
          'spider-run-bottom-left-2',
          'spider-run-bottom-left-3',
          'spider-run-bottom-left-4',
          'spider-run-bottom-left-5',
          'spider-run-bottom-left-6',
          'spider-run-bottom-left-7',
          'spider-run-bottom-left-8',
          'spider-run-bottom-left-9',
          'spider-run-bottom-left-10',
          'spider-run-bottom-left-11',
          'spider-run-bottom-left-12',
          'spider-run-bottom-left-13',
          'spider-run-bottom-left-14',
          'spider-run-bottom-left-15',
        ],
        'spider-run-left': [
          'spider-run-left-0',
          'spider-run-left-1',
          'spider-run-left-2',
          'spider-run-left-3',
          'spider-run-left-4',
          'spider-run-left-5',
          'spider-run-left-6',
          'spider-run-left-7',
          'spider-run-left-8',
          'spider-run-left-9',
          'spider-run-left-10',
          'spider-run-left-11',
          'spider-run-left-12',
          'spider-run-left-13',
          'spider-run-left-14',
          'spider-run-left-15',
        ],
        'spider-run-top-left': [
          'spider-run-top-left-0',
          'spider-run-top-left-1',
          'spider-run-top-left-2',
          'spider-run-top-left-3',
          'spider-run-top-left-4',
          'spider-run-top-left-5',
          'spider-run-top-left-6',
          'spider-run-top-left-7',
          'spider-run-top-left-8',
          'spider-run-top-left-9',
          'spider-run-top-left-10',
          'spider-run-top-left-11',
          'spider-run-top-left-12',
          'spider-run-top-left-13',
          'spider-run-top-left-14',
          'spider-run-top-left-15',
        ],
        'spider-run-top': [
          'spider-run-top-0',
          'spider-run-top-1',
          'spider-run-top-2',
          'spider-run-top-3',
          'spider-run-top-4',
          'spider-run-top-5',
          'spider-run-top-6',
          'spider-run-top-7',
          'spider-run-top-8',
          'spider-run-top-9',
          'spider-run-top-10',
          'spider-run-top-11',
          'spider-run-top-12',
          'spider-run-top-13',
          'spider-run-top-14',
          'spider-run-top-15',
        ],
      },
    },
  },
  {
    name: 'spider-walk',
    metadata: {
      frames: {
        'spider-walk-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'spider-walk-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/spider/walk.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'spider-walk-bottom': [
          'spider-walk-bottom-0',
          'spider-walk-bottom-1',
          'spider-walk-bottom-2',
          'spider-walk-bottom-3',
          'spider-walk-bottom-4',
          'spider-walk-bottom-5',
          'spider-walk-bottom-6',
          'spider-walk-bottom-7',
          'spider-walk-bottom-8',
          'spider-walk-bottom-9',
          'spider-walk-bottom-10',
          'spider-walk-bottom-11',
          'spider-walk-bottom-12',
          'spider-walk-bottom-13',
          'spider-walk-bottom-14',
          'spider-walk-bottom-15',
        ],
        'spider-walk-bottom-left': [
          'spider-walk-bottom-left-0',
          'spider-walk-bottom-left-1',
          'spider-walk-bottom-left-2',
          'spider-walk-bottom-left-3',
          'spider-walk-bottom-left-4',
          'spider-walk-bottom-left-5',
          'spider-walk-bottom-left-6',
          'spider-walk-bottom-left-7',
          'spider-walk-bottom-left-8',
          'spider-walk-bottom-left-9',
          'spider-walk-bottom-left-10',
          'spider-walk-bottom-left-11',
          'spider-walk-bottom-left-12',
          'spider-walk-bottom-left-13',
          'spider-walk-bottom-left-14',
          'spider-walk-bottom-left-15',
        ],
        'spider-walk-left': [
          'spider-walk-left-0',
          'spider-walk-left-1',
          'spider-walk-left-2',
          'spider-walk-left-3',
          'spider-walk-left-4',
          'spider-walk-left-5',
          'spider-walk-left-6',
          'spider-walk-left-7',
          'spider-walk-left-8',
          'spider-walk-left-9',
          'spider-walk-left-10',
          'spider-walk-left-11',
          'spider-walk-left-12',
          'spider-walk-left-13',
          'spider-walk-left-14',
          'spider-walk-left-15',
        ],
        'spider-walk-top-left': [
          'spider-walk-top-left-0',
          'spider-walk-top-left-1',
          'spider-walk-top-left-2',
          'spider-walk-top-left-3',
          'spider-walk-top-left-4',
          'spider-walk-top-left-5',
          'spider-walk-top-left-6',
          'spider-walk-top-left-7',
          'spider-walk-top-left-8',
          'spider-walk-top-left-9',
          'spider-walk-top-left-10',
          'spider-walk-top-left-11',
          'spider-walk-top-left-12',
          'spider-walk-top-left-13',
          'spider-walk-top-left-14',
          'spider-walk-top-left-15',
        ],
        'spider-walk-top': [
          'spider-walk-top-0',
          'spider-walk-top-1',
          'spider-walk-top-2',
          'spider-walk-top-3',
          'spider-walk-top-4',
          'spider-walk-top-5',
          'spider-walk-top-6',
          'spider-walk-top-7',
          'spider-walk-top-8',
          'spider-walk-top-9',
          'spider-walk-top-10',
          'spider-walk-top-11',
          'spider-walk-top-12',
          'spider-walk-top-13',
          'spider-walk-top-14',
          'spider-walk-top-15',
        ],
      },
    },
  },
];
